// extracted by mini-css-extract-plugin
export var arrow = "_kv-1";
export var content = "_kv-0";
export var highlighted = "_kv-2";